module.exports = __webpack_public_path__ + "static/media/antigua-accommodation-13.6b8ca24e.jpg";